export default "__VITE_ASSET__CeCiRfn7__"